/**
 * 権限チェック
 */

/**
 * ロボ編集権限チェック
 * @param {Object} robo ロボオブジェクト
 * @param {Object} user ユーザーオブジェクト
 * @returns Boolean
 */
const isRoboEditPermission = function (robo, user) {
  // スーパーユーザーは編集可
  if (user.isAgent === true) {
    return true
  }
  // 作成者は編集可
  if (robo.create_by === user.userHash) {
    return true
  }
  // 編集者は編集可
  if (robo.editor) {
    if (robo.editor.includes(user.userHash)) {
      return true
    }
  }
  return false
}

/**
 * ロボ閲覧権限チェック
 * @param {Object} robo ロボオブジェクト
 * @param {Object} user ユーザーオブジェクト
 * @returns Boolean
 */
const isRoboDisplayPermission = function (robo, user) {
  // スーパーユーザーは閲覧可
  if (user.isAgent === true) {
    return true
  }
  // 作成者は閲覧可
  if (robo.create_by === user.userHash) {
    return true
  }
  // 閲覧権限設定なしロボは閲覧可
  if (robo.is_permitted === false) {
    return true
  }
  // 編集者は閲覧可
  if (robo.editor) {
    if (robo.editor.includes(user.userHash)) {
      return true
    }
  }
  // 閲覧権限ありユーザーは閲覧可
  if (robo.permit_users) {
    if (robo.permit_users.users) {
      if (robo.permit_users.users.includes(user.userHash)) {
        return true
      }
    }
  }
  return false
}

export {
  isRoboEditPermission,
  isRoboDisplayPermission
}


// WEBPACK FOOTER //
// ./src/functions/checkPermission.js